import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { UserType } from '../types';
import { Logo } from './Logo';

interface LayoutProps {
  children: React.ReactNode;
}

export const Layout: React.FC<LayoutProps> = ({ children }) => {
  return (
    <div className="layout">
      <header className="header">
        <div className="header-container">
          <Link to="/admin/login" className="logo-link">
            <Logo size="md" variant="full" />
          </Link>

          <nav className="nav">
            <span className="nav-text">Admin Portal</span>
          </nav>
        </div>
      </header>

      <main className="main-content">
        {children}
      </main>

      <footer className="footer">
        <div className="footer-container">
          <p>&copy; 2025 Coin MFI - Admin Dashboard. All rights reserved.</p>
          <p className="footer-powered">Powered by <a href="https://www.aionloop.ca" target="_blank" rel="noopener noreferrer">www.aionloop.ca</a></p>
        </div>
      </footer>
    </div>
  );
};
